module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0.48)), url(' + _vm.set_gallery_banner_image + ')'
    }),
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d0e1a3e"}!./src/pages/Buypoint/Buypoint/template.html
// module id = 203
// module chunks = 1